import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="sortable"
export default class extends Controller {

  connect() {
    this.form = this.element
    this.checkboxes = this.form.querySelectorAll('input[type="checkbox"]')
    this.textInputs = this.form.querySelectorAll('input[type="text"]')

    this.checkboxes.forEach(checkbox => {
      checkbox.addEventListener("change", (event) => this.handleCheckboxChange(event))
    })

    this.textInputs.forEach(input => {
      input.addEventListener("input", () => this.handleTextInput())
    })
  }

  handleCheckboxChange(event) {
    const clicked = event.target

    // Uncheck all other checkboxes
    this.checkboxes.forEach(box => {
      if (box !== clicked) {
        box.checked = false
      }
    })
    this.form.requestSubmit()
  }

  handleTextInput() {
    this.checkboxes.forEach(box => {
      box.checked = false
    })
    if (window.location.pathname !== "/") {
      Turbo.visit("/", { action: "restore" })
    }
    this.form.requestSubmit()
  }
}
